import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";


const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";
const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength);
    }
    return text;
  };
  
  const stripHtmlTags = (html, maxLength) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const strippedText = tempDiv.textContent || tempDiv.innerText || "";
    return truncateText(strippedText, maxLength);
  };

function EkaDashi() {
    const [postData, setPostData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            "https://api.shabdtoday.com/api/home/ekadasi"
          );
          setPostData(response.data);
          setLoading(false);
        } catch (error) {
          setError(error.message);
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);
  
  

  
  
    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {/* <Circles
            height="30"
            width="30"
            color="#f7265c"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          /> */}
        </div>
      );
    }
  
    if (error) {
      return <div>Error: {error}</div>;
    }
    return (
        <div>
            <div className="ak-block-header ak-block-header-style-5 no-tabs mt-2">
                <div
                    className="main-wdgt container"
                    id="widget-rs-4937"
                    data-vars-widget-type="home"
                    data-vars-widget-name="astrology"
                    data-vars-orderid={10}
                >
                   <div>
                        <h1 className='head' style={{ color: 'crimson' }}>
                        एकादशी
                        </h1>
                      </div>
                </div>
            </div>
            <div className="n_w_p_body">
                <div className="joytish_vishesh_img">
                    <ul>
                        <li>
                        {postData.ekadasi.slice(0, 1).map((post) => (

                          <div key={post.mainKhabarId}>
                          <Link to={`/Daram-News/${post.mainKhabarId}`} aria-label="एकादशी">
                                <img
                                    alt="रामशलाका"
                                    width={145}
                                    height={72}
                                    src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=145&h=72&outtype=webp"}
                                    className="img-fluid"
                                />
                            </Link>
                          </div>
                        ))}
                        </li>
                        <li>
                        {postData.ekadasi.slice(1, 2).map((post) => (

                          <div  key={post.mainKhabarId}>
                           <Link to={`/Daram-News/${post.mainKhabarId}`} aria-label="एकादशी">
                                <img
                                    alt="टैरो भविष्यवाणी"
                                    width={145}
                                    height={72}
                                    src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=145&h=72&outtype=webp"}
                                    className="img-fluid"
                                />
                            </Link>
                           </div>
                        ))}
                        </li>

                        <li>
                        {postData.ekadasi.slice(2, 3).map((post) => (

                           <div  key={post.mainKhabarId}>
                           <Link to={`/Daram-News/${post.mainKhabarId}`} aria-label="एकादशी">
                                <img
                                    alt=" पत्रिका मिलान"
                                    width={145}
                                    height={72}
                                    src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=145&h=72&outtype=webp"}
                                    className="img-fluid"
                                />
                            </Link>
                           </div>
                        ))}
                        </li>
                        <li>
                        {postData.ekadasi.slice(3, 4).map((post) => (

                          <div  key={post.mainKhabarId}>
                          <Link to={`/Daram-News/${post.mainKhabarId}`} aria-label="एकादशी">
                                <img
                                    alt="जन्म कुंडली"
                                    width={145}
                                    height={72}
                                    src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=145&h=72&outtype=webp"}
                                    className="img-fluid"
                                />
                            </Link>
                          </div>
                        ))}
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    )
}

export default EkaDashi
